
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/best-ai-chat-ui",
      function () {
        return require("private-next-pages/best-ai-chat-ui.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/best-ai-chat-ui"])
      });
    }
  